var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.499023,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "#7E0832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1758 0.499023L19.3758 2.89902L12.1758 5.29902L19.3758 7.69902L12.1758 10.099L19.3758 12.499L12.1758 14.899L19.3758 17.299L12.1758 19.699L19.3758 22.099L12.1758 24.499L19.3758 26.899L12.1758 29.299L19.3758 31.699L12.1758 34.099L19.3758 36.499H0.175781V0.499023H12.1758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88162"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.499023,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/Qatar.cd2acfb4e54897b448ebbf3007375ca8.svg";
export { ForwardRef as ReactComponent };